import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.addDocument`,
    defaultMessage: 'Add Document',
  },
  remove: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.remove`,
    defaultMessage: 'Remove',
  },
  removeDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocument`,
    defaultMessage: 'Remove Document',
  },
  removeDocumentConfirmationText: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocumentConfirmationText`,
    defaultMessage: `Are you sure you want to remove the "{title}" document?`,
  },
  documents: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.documents`,
    defaultMessage: 'Documents',
  },
  // AXHE-4106: offer letter templates share this list with legacy documents, so
  // the row has to say which kind it is — the two are configured in different
  // places and only one opens the offer letter editor.
  offerLetterBadge: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.offerLetterBadge`,
    defaultMessage: 'Offer letter template',
  },
  // BaseStageSerializer#offer_letter_templates_for_stage deliberately surfaces
  // an assigned-but-INACTIVE template so a recruiter can clear a stale
  // assignment (AXHE-3836). Rendering it identically to an active one meant the
  // detach action worked but the reason to use it was invisible — the recruiter
  // could not tell why the row was there (rantler, PR #2996).
  offerLetterInactiveBadge: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.offerLetterInactiveBadge`,
    defaultMessage: 'Offer letter template (inactive)',
  },
  noDocuments: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocuments`,
    defaultMessage: 'No documents added yet.',
  },
  noDocumentsError: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocumentsError`,
    defaultMessage:
      'At least one document is required for this stage to work, please add.',
  },
  templateTitleMissing: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.templateTitleMissing`,
    defaultMessage: 'Template title missing',
  },
  uploadDocumentTemplates: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.uploadDocumentTemplates`,
    defaultMessage:
      'Upload document templates in <link>company settings</link> to use in this stage.',
  },
});
